export const state = () => {
	return {
		plan: null,
		yearly: false,
		useKlarna: false
	}
}

export const getters = {
	getInstallmentPlan (state) {
		return state.plan
	},
	getYearlySubscription (state) {
		return state.yearly
	},
	getUseKlarnaPayment (state) {
		return state.useKlarna
	}
}

export const actions = {}

export const mutations = {
	setInstallmentPlan (state, plan = {}) {
		state.plan = plan
	},
	setYearlySubscription (state, yearly = false) {
		state.yearly = yearly
	},
	setUseKlarnaPayment (state, useKlarna = false) {
		state.useKlarna = useKlarna
	}
}
